export const initialModifyGroupState = {
  data: {},
  loading: false,
};
